import React from "react";
// import Layout from 'layout/index.js'

import { Link } from 'react-router-dom';

import NumberFormat from 'react-number-format';


// import SearchIcon from '@mui/icons-material/Search';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';

import VehiculoSii from "./VehiculoSii";
// import CompareArrowsIcon from '@mui/icons-material/CompareArrows';

import EditIcon from '@mui/icons-material/Edit';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SearchIcon from '@mui/icons-material/Search';
import ListAltIcon from '@mui/icons-material/ListAlt';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SyncIcon from '@mui/icons-material/Sync';

import { authenticationService } from 'auth/authenticationService'
import {
          // Paper,
          Box,
        //   Button,
          Typography,
          Alert,
        //   TextField,
          // TableSortLabel,TableContainer,Table,TableRow,TableHead,TableBody,TableCell,
          TablePagination,
          Grid,
          Card, CardContent,
          Button,
          CircularProgress,
          Dialog, DialogContent, DialogActions, 
          FormControlLabel, Switch,TextField

        } from '@mui/material';


const NumberFormatCustom = React.forwardRef(function NumberFormatCustom( props, ref  ) {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
      decimalScale={0}
      prefix="$"
    />
  );
});

// const headCells = [
//   { id: "patente", numeric: false,disablePadding: false,label: "Patente", sorting: true},
//   { id: "estado_identificacion", numeric: false, disablePadding: false, label: "Estado identificación vehículo", sorting: false},
//   { id: "estado_prt", numeric: false,disablePadding: false,label: "Estado PRT", sorting: false},
//   { id: "estado_soap", numeric: false,disablePadding: false,label: "Estado SOAP", sorting: false},
//   { id: "estado_sii", numeric: false, disablePadding: false, label: "Estado tasación SII", sorting: false},
//   { id: "estado_multas", numeric: false, disablePadding: false, label: "Estado multas", sorting: false},
//   { id: "estado_pago", numeric: false, disablePadding: false, label: "Estado pago", sorting: false},
// ];


function encodeQueryData(data) {
   const ret = [];
   for (let d in data)
     ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
   return ret.join('&');
}

class Factibilizaciones extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

      objects: [],

      html: {
        list: true,
        exportar_button:false,
        uploading_excel:false,
        edit_monto_factura: []
      },
      filters: {
      },
      pagination:{
        page: 0,
        pages_num: 1,
        rows_num: -1,
        rows_per_page: 10,
      },
      sorting: {
        order_by:'id',
        order:'asc',
      },
      dialog_sii:{
        open:false,
        marca: null,
        modelo: null,
        agno: null,
        current_index: null,
      }
    };

    this.handleLoad = this.handleLoad.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.createNew = this.createNew.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleUpdateFactibilizacion = this.handleUpdateFactibilizacion.bind(this);
    this.handleUpdateAllFactibilizaciones = this.handleUpdateAllFactibilizaciones.bind(this);

    this.toBase64 = this.toBase64.bind(this);
    this.handleSubmitExcel = this.handleSubmitExcel.bind(this);
    this.handleFile = this.handleFile.bind(this);

    this.openDialogSii = this.openDialogSii.bind(this);
    this.closeDialogSii = this.closeDialogSii.bind(this);
    this.handleImportSii = this.handleImportSii.bind(this);

    this.handleInputChange = this.handleInputChange.bind(this);
  }



  handleChangePage(event, page){
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
          page: page,
      }}), ()=> this.handleLoad());

  }
  handleChangeRowsPerPage(event){
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
          rows_per_page: event.target.value,
      }}), ()=> this.handleLoad());
  }

  handleSort(event, property){
    const isAsc = this.state.sorting.order_by === property && this.state.sorting.order === "asc";
    this.setState(prevState => ({
      sorting: {
          ...prevState.sorting,
          order: isAsc ? "desc" : "asc",
          order_by: property,
    }}),()=>this.handleLoad()
    );

  }


  handleLoad(event=false,xlsx = false, multas = false){
    if(event){
      event.preventDefault();
    }
    this.setState(prevState => ({
      html: {
        ...prevState.html,
        cargando_lista: true,
      },
    }));

    var params = {
        page: this.state.pagination.page+1,
        order_by: this.state.sorting.order_by,
        order: this.state.sorting.order,
        rows_per_page: this.state.pagination.rows_per_page,
    };
    console.log('lista_uuid: ', this.props.lista_uuid)
    if(this.props.lista_uuid && this.props.lista_uuid!==''){
      params['lista_uuid'] = this.props.lista_uuid;
    }

    if(xlsx){
      params['xlsx'] = true;
      this.setState(prevState => ({
        html: {
          ...prevState.html,
          exportar_button: true,
        },
      }));
    }
    if(multas){
      params['multas'] = true;
      this.setState(prevState => ({
        html: {
          ...prevState.html,
          exportar_button: true,
        },
      }));
    }

    var query = encodeQueryData(params)

    let fetch_params = {
      url:'/permisos/factibilizacion/?'+query,
      method: 'GET',
    }

    if(xlsx || multas){
      fetch_params['ContentType'] = 'file';
    }



    authenticationService.fetchApi(fetch_params)
    .then(result=>{
      if(xlsx){
        result.blob().then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            console.log(url);
            a.href = url;
            a.download = 'lista_vehiculos.xlsx';
            a.click();
        });

        this.setState(prevState => ({
          html: {
            ...prevState.html,
            exportar_button: false,
            cargando_lista: false,
            uploading_excel:false,
          },
        }));
      }
      else if(multas){
        result.blob().then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            console.log(url);
            a.href = url;
            a.download = 'lista_multas.xlsx';
            a.click();
        });

        this.setState(prevState => ({
          html: {
            ...prevState.html,
            exportar_button: false,
            cargando_lista: false,
            uploading_excel:false,
          },
        }));
      }
      else {
        let list = false;
        if(result.data.length > 0){
          list=true;
        }
        let buttons = []
        result.data.map((object,index) => buttons[index]=false );
        
        this.setState(prevState => ({
          pagination: {
              ...prevState.pagination,
              rows_num: result.rows_num
          },
          html: {
            ...prevState.html,
            list: list,
            update_status: buttons,
            cargando_lista: false,
            uploading_excel:false,
          },
          objects: result.data
        }),()=>{
          let edit_monto_factura = []
          this.state.objects.map((idx,object)=>{
            edit_monto_factura[idx] = false
          });
          this.setState(prevState=>({
            html:{...prevState.html,
              edit_monto_factura:edit_monto_factura, 
            }
          }))
          
        });
      }
      
    })
    .catch(err=>{
      this.setState(prevState => ({
        html: {
          ...prevState.html,
          exportar_button: false,
          cargando_lista: false,
          uploading_excel:false,
        },
      }));
    });
  }
  
  editMontoFactura(index){
    let edit_monto_factura = this.state.html.edit_monto_factura;
    edit_monto_factura[index] = edit_monto_factura[index]?false:true;
    this.setState(prevState=>({
      html:{...prevState.html,
        edit_monto_factura:edit_monto_factura
      }
    }));
  }

  componentDidMount(){
    // console.log(1111);
    this.handleLoad();
  }

  createNew(){
    this.setState(prevState => ({
      html: {
        ...prevState.html,
        list: false,
      },
    }));
  }
  handleFilterChange(event) {
    const { filters } = { ...this.state };
    const currentState = filters;
    const { name, value } = event.target;
    currentState[name] = value;
    this.setState({ filters: currentState },()=>{
      this.handleLoad();
    });

  }

  handleInputChange(event,index) {
    const { filters } = { ...this.state };
    const currentState = this.state.objects;
    const { name, value } = event.target;
    currentState[index][name] = value;

    this.setState({ objects: currentState },()=>{
      
    });

  }

  handleUpdateAllFactibilizaciones(event){
    let {objects} = this.state;
    
    this.setState(prevState => ({
      html: {
        ...prevState.html,
        update_all_status: true,
      },
    }));
    objects.map((object,index) => {
      this.handleUpdateFactibilizacion(null, {index: index});

      return(true);
    });


    this.setState(prevState => ({
      html: {
        ...prevState.html,
        update_all_status: false,
      },
    }));
  }

  handleUpdateFactibilizacion(event,params) {
    let index = params.index;
    params['factibilizacion_uuid']=this.state.objects[index].factibilizacion_uuid;

    let buttons = this.state.html.update_status;
    buttons.map((object,index2) => {
      if(index === index2){
        buttons[index]=true;
      }
      return(true);
    });
    this.setState(prevState => ({
      html: {
        ...prevState.html,
        update_status: buttons,
      },
    }));

    
    
    authenticationService.fetchApi({
        url: '/permisos/factibilizacion/',
        method: 'POST',
        body: JSON.stringify(params),
    })
    .then((result)=>{
      console.log(index)
      // this.handleLoad()
      const {objects} = this.state
      objects[index] = result

      this.setState({objects: objects},()=>{
        let edit_monto_factura = this.state.html.edit_monto_factura;
        edit_monto_factura[index]=false;
        buttons.map((object,index2) => {
          if(index === index2){
            buttons[index]=false;
          }
          return(true);
        });
        this.setState(prevState => ({
          html: {
            ...prevState.html,
            update_status: buttons,
            edit_monto_factura:edit_monto_factura
          },
        }));

      });

    })
    .catch(err => {

    });
  }


  toBase64(file) {
    return(
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      })
  )}
  handleSubmitExcel() {
    
    let params = {
      lista_uuid: this.props.lista_uuid
    }
    if(this.state.excelVehiculos!==''){
      params['excelVehiculos'] = this.state.excelVehiculos;
    }

    authenticationService.fetchApi({
        url: '/permisos/factibilizacion/',
        method: 'POST',
        body: JSON.stringify(params),
    })
    .then((result)=>{
      this.handleLoad();

    })
    .catch(err => {

    });
  }

  handleFile(event) {
    const {files } = event.target
    const file = files[0];

    console.log(1111)
    if (file.type !== undefined && file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      this.toBase64(file).then(encodedFile => {
        this.setState(prevState => ({
          excelVehiculos: encodedFile,
          html:{...prevState.html,
            uploading_excel: true
          }
        }),()=>{
          this.handleSubmitExcel();
        });
      });
    }
    else {
      //
    }
  }
  openDialogSii(index){

    let agno = this.state.objects[index].agno?parseInt(Number(this.state.objects[index].agno)):null;
    let modelo;
    let modelo_completo;
    
    if(this.state.objects[index].modelo){
      let modelo_array = this.state.objects[index].modelo.split(' ')
      if(modelo_array.length>1){
        modelo = modelo_array.slice(0, 1).join(' ');
        modelo_completo = this.state.objects[index].modelo
      }
      else{
        modelo = this.state.objects[index].modelo;
        modelo_completo = null;
      }
    }
    else{
      modelo = null;
      modelo_completo = null;
    }
    this.setState(prevState=>({
      dialog_sii:{...prevState.dialog_sii,
        open:true,
        marca: this.state.objects[index].marca,
        modelo: modelo,
        modelo_completo:modelo_completo,
        agno: agno,
        current_index: index
      }
      }),()=>{
      // this.handleLoad()
    })
  }
  closeDialogSii(){
    this.setState({dialog_sii:{open:false}},()=>{
      // this.handleLoad()
    })
  }
  handleImportSii(vehiculo_sii_id, index){
    this.handleUpdateFactibilizacion(null,{vehiculo_sii_id:vehiculo_sii_id, index:index});

    this.setState(prevState=>({
      dialog_sii:{...prevState.dialog_sii,
        open:false,
        marca: null,
        modelo: null,
        modelo_completo:null,
        agno: null,
        current_index: null
      }
      }),()=>{
    })
    
  }

  render() {
    return (
    
        <Box>
          <Box>
            <Box p={3}>
              <Typography variant='h5'>
                Vehículos en lista
              </Typography>
            </Box>
            <Box textAlign='right'>
              <input  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      
                      style={{ display: 'none' }}
                      id="button-file"
                      multiple
                      type="file"
                      name='excelVehiculos'
                      onChange={this.handleFile}
                    />
              <label htmlFor="button-file">
                <Button startIcon={this.state.html.uploading_excel?<CircularProgress size={20}/>:<FileUploadIcon/>} 
                        disabled={this.state.html.uploading_excel?true:false} 
                        variant="contained" 
                        component="span" 
                        color='primary'>
                  Subir una nueva lista
                </Button>
                &nbsp;
                
              </label> 
              <Button variant="contained" 
                        component="span" 
                        color='secondary'
                        startIcon={this.state.html.update_all_status ? <CircularProgress size={20}/> : <SettingsInputAntennaIcon />}
                        disabled={this.state.html.update_all_status ? true : false}
                        onClick={this.handleUpdateAllFactibilizaciones}
                        >
                  Actualizar todos los vehículos visibles
              </Button>
            </Box>
            <Box>

              <Button variant="contained" 
                        component="span" 
                        color='secondary'
                        startIcon={this.state.html.exportar_button ? <CircularProgress size={20}/> : <DownloadIcon />}
                        disabled={this.state.html.exportar_button ? true : false}
                        onClick={(event)=>this.handleLoad(false,true)}
                        >
                  Descargar lista
              </Button>

              &nbsp;
              <Button variant="outlined" 
                        component="span" 
                        color='secondary'
                        startIcon={this.state.html.exportar_button ? <CircularProgress size={20}/> : <DownloadIcon />}
                        disabled={this.state.html.exportar_button ? true : false}
                        onClick={(event)=>this.handleLoad(false,false,true)}
                        >
                  Descargar multas
              </Button>
            </Box>
          </Box>
          {this.state.html.cargando_lista &&
            <CircularProgress />
          }
          <Box>
            {this.state.objects && this.state.objects.length>0 && this.state.html.list && !this.state.html.cargando_lista &&
            <Box>
              <TablePagination
                labelRowsPerPage='Resultados por página'
                component="div"
                count={this.state.pagination.rows_num}
                page={this.state.pagination.page}
                onPageChange={this.handleChangePage}
                rowsPerPage={this.state.pagination.rows_per_page}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
              {/* {console.log(this.state.objects)} */}
              {this.state.objects && this.state.objects.length>0 && this.state.objects.map((object,index) => {
                // console.log('Index',index);
                // console.log('object:',this.state.objects[index]);
                return(

                <Box mb={1} key={this.state.objects[index].factibilizacion_uuid}>
                  <Card>
                    <CardContent>

                      <Grid container spacing={1}>
                        <Grid item sm={12} md={12}>
                          <Box sx={{backgroundColor:"#EEEEFF",borderRadius:'5px'}} p={1}>
                            <Grid container>
                              <Grid item xs={6}>
                                <Box pt={1} sx={{fontWeight:'Bold'}}>Patente: {this.state.objects[index].patente}</Box>
                                <Typography variant="caption">
                                  <Box pt={1} sx={{}}>Marca: {this.state.objects[index].marca?this.state.objects[index].marca:null}</Box>
                                  <Box sx={{}}>Modelo: {this.state.objects[index].modelo?this.state.objects[index].modelo:null}</Box>
                                  <Box sx={{}}>Año: {this.state.objects[index].agno?parseInt(Number(this.state.objects[index].agno)):null}</Box>
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Box align='right'>
                                  <Button color='primary' 
                                          onClick={event => this.handleUpdateFactibilizacion(event,{index:index})}
                                          startIcon={this.state.html.update_status[index] ? <CircularProgress size={20}/> : <SettingsInputAntennaIcon />}
                                          disabled={this.state.html.update_status[index] ? true : false}
                                          >
                                    Actualizar SOAP y PRT
                                  </Button>
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>
                        
                        <Grid item sm={12} md={2}>
                          { this.state.objects[index].estado_prt === 1 &&
                          <Box>
                            <Alert severity='success' icon={false} >
                                Consulta Revisión Técnica ok
                            </Alert>
                            <Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{display:'inline', fontWeight:'bold'}}>Fecha consulta: &nbsp;</Box>
                                  {(new Date(this.state.objects[index].prt.fecha_consulta)).toLocaleString('es-CL')}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{display:'inline', fontWeight:'bold'}}>Fecha de vencimiento revisión: &nbsp;</Box>
                                {this.state.objects[index].prt.revision_fecha_vencimiento}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>  Planta revisión técnica: &nbsp;</Box>
                                {this.state.objects[index].prt.revision_direccion_prt + ', ' +  this.state.objects[index].prt.revision_comuna_prt}
                                </Typography>
                              </Box>
                              
                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Código gases: &nbsp;</Box>
                                {this.state.objects[index].prt.gases_codigo_prt}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Resultado gases: &nbsp;</Box>
                                {this.state.objects[index].prt.gases_cod_resultado}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Mensaje gases: &nbsp;</Box>
                                {this.state.objects[index].prt.gases_mensaje_resultado}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Número certificado gases: &nbsp;</Box>
                                {this.state.objects[index].prt.gases_numero_certificado}
                                </Typography>
                              </Box>

                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Código revisión técnica: &nbsp;</Box>
                                {this.state.objects[index].prt.revision_codigo_prt}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{display:'inline', fontWeight:'bold'}}>Resultado revisión técnica: &nbsp;</Box>
                                {this.state.objects[index].prt.revision_cod_resultado}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Mensaje revisión técnica: &nbsp;</Box>
                                {this.state.objects[index].prt.revision_mensaje_resultado}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{display:'inline', fontWeight:'bold'}}>Número certificado revisión técnica: &nbsp;</Box>
                                {this.state.objects[index].prt.revision_numero_certificado}
                                </Typography>
                              </Box>

                            </Box>
                          </Box>
                          }
                          { this.state.objects[index].estado_prt === 0 &&
                          
                            <Alert severity='info' icon={false} >
                                Revisión Técnica sin consultar
                            </Alert>
                          
                          }
                          { this.state.objects[index].estado_prt === 2 &&
                          
                            <Alert severity='error' icon={false} >
                                Revisión Técnica incompleta  (Web service sin resultados)
                            </Alert>
                          
                          }
                        </Grid>
                        <Grid item sm={12} md={2}>
                          { this.state.objects[index].estado_soap === 1 &&
                          <Box>
                            <Alert severity='success' icon={false}>
                                Consulta Soap Ok
                            </Alert>
                            <Box>
                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Fecha consulta: &nbsp;</Box>
                                  {(new Date(this.state.objects[index].soap.created_at)).toLocaleString('es-CL')}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Fecha de vencimiento seguro: &nbsp;</Box>
                                {this.state.objects[index].soap.fecha_termino}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Empresa seguro: &nbsp;</Box>
                                {this.state.objects[index].soap.nombre_compania}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Rut empresa: &nbsp;</Box>
                                {this.state.objects[index].soap.rut_compania}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Patente: &nbsp;</Box>
                                {this.state.objects[index].soap.patente}
                                </Typography>
                              </Box>
                              {/* <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Año fabricación: &nbsp;</Box>
                                {this.state.objects[index].soap.agno_fabricacion}
                                </Typography>
                              </Box> */}
                              {/* <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Número de folio: &nbsp;</Box>
                                {this.state.objects[index].soap.nro_folio}
                                </Typography>
                              </Box> */}
                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Número de poliza: &nbsp;</Box>
                                {this.state.objects[index].soap.nro_poliza}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Ticket: &nbsp;</Box>
                                {this.state.objects[index].soap.ticket}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                          }
                          { this.state.objects[index].estado_soap === 0 &&
                            <Alert severity='info' icon={false} >
                                Soap sin consultar
                            </Alert>
                          }
                          { this.state.objects[index].estado_soap === 2 &&
                            <Alert severity='error' icon={false} >
                                Soap incompelto (Web service sin resultados)
                            </Alert>
                          }
                        </Grid>
                        
                        <Grid item sm={12} md={2}>
                          { this.state.objects[index].estado_multas === 0 &&
                          <Box>

                            <Alert severity='info' icon={false} >
                                Multas sin consultar
                            </Alert>
                          </Box>
                          }
                          { this.state.objects[index].estado_multas === 1 &&
                          <Box>

                            <Alert severity='success' icon={false}>
                              Consulta Multas Ok
                            </Alert>
                            <Box>
                              <Typography variant="caption">
                                  <Box sx={{display:'inline', fontWeight:'bold'}}>Cuantas Multas:</Box>
                                  {this.state.objects[index].total_multas_utm}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography variant="caption">
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Total Multas que son en pesos: </Box>
                                {this.state.objects[index].total_multas_pesos}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography variant="caption">
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Total Multas que son en UTM: </Box>
                                {this.state.objects[index].total_multas_utm}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography variant="caption">
                                <Box sx={{display:'inline', fontWeight:'bold'}}>Total Multas Arancel: </Box>
                                {this.state.objects[index].total_multas_arancel}
                              </Typography>
                            </Box>
                            {this.state.objects[index].multas && this.state.objects[index].multas.map((object2,index2) => {
                            
                            return(
                              <>
                                {/* {console.log(this.state.objects[index])} */}
                                <Box  p={1} 
                                      m={1} 
                                      sx={{ border:1, borderColor: 'primary.main' , borderRadius: 1}} 
                                      key={object.id + '_index_' + this.state.objects[index].factibilizacion_uuid}>
                                  <Box>
                                    <Typography variant="caption" sx={{fontWeight:'Bold'}}>Monto Multa:&nbsp;</Typography>
                                    <Typography variant="caption">
                                    <NumberFormat displayType={'text'}
                                                    value={object2.monto}
                                                    decimalScale={2}
                                                    prefix={'$'} />
                                                    &nbsp;
                                    {object2.tipo_moneda===2?'UTM':object2.tipo_moneda===1?'pesos':'UF'}</Typography>
                                  </Box>
                                  <Box>
                                    <Typography variant="caption" sx={{fontWeight:'Bold'}}>Comuna Multa:&nbsp;</Typography>
                                    <Typography variant="caption">{object2.comuna}</Typography>
                                  </Box>

                                  <Box>
                                    <Typography variant="caption" sx={{fontWeight:'Bold'}}>Rol Causa:&nbsp;</Typography>
                                    <Typography variant="caption">{object2.rol_causa}</Typography>
                                  </Box>
                                  <Box>
                                    <Typography variant="caption" sx={{fontWeight:'Bold'}}>Fecha infracción:&nbsp;</Typography>
                                    
                                    <Typography variant="caption">{(new Date(object2.fecha_infraccion)).toLocaleDateString('es-CL')}</Typography>
                                  
                                  </Box>
                                  <Box>
                                    <Typography variant="caption" sx={{fontWeight:'Bold'}}>Fecha sentencia:&nbsp;</Typography>
                                    <Typography variant="caption">{(new Date(object2.fecha_sentencia)).toLocaleDateString('es-CL')}</Typography>
                                  </Box>
                                </Box>
                              </>
                              
                              )})}
                          </Box>
                          }
                        </Grid>
                        <Grid item sm={12} md={6}>
                          { this.state.objects[index].estado_sii === 1 &&
                          <Alert severity='success' icon={false} >
                            Tasación OK
                          </Alert>
                          }
                          { this.state.objects[index].estado_sii === 0 &&
                          <Box>
                            <Alert severity='info' icon={false} >
                                Tasación SII 
                                sin resolución
                            </Alert>
                          </Box>
                          }

                          { this.state.objects[index].estado_sii === 2 &&
                            <Alert severity='error' icon={false} >
                              Otro caso
                            </Alert>
                          }
                          { this.state.objects[index].vehiculo_sii &&
                          <Box>
                            <Box pl={1}>
                              <Typography variant="caption" sx={{fontWeight:'Bold'}}>Marca SII:&nbsp;</Typography>
                              <Typography variant="caption">{this.state.objects[index].vehiculo_sii.marca}</Typography>
                            </Box>
                            <Box pl={1}>
                              <Typography variant="caption" sx={{fontWeight:'Bold'}}>Modelo SII:&nbsp;</Typography>
                              <Typography variant="caption">{this.state.objects[index].vehiculo_sii.modelo}</Typography>
                            </Box>
                            <Box pl={1}>
                              <Typography variant="caption" sx={{fontWeight:'Bold'}}>Año SII:&nbsp;</Typography>
                              <Typography variant="caption">{this.state.objects[index].vehiculo_sii.agno}</Typography>
                            </Box>
                            <Box pl={1}>
                              <Typography variant="caption" sx={{fontWeight:'Bold'}}>Código SII:&nbsp;</Typography>
                              <Typography variant="caption">{this.state.objects[index].vehiculo_sii.codigo_sii}</Typography>
                            </Box>
                            <Box pl={1}>
                              <Typography variant="caption" sx={{fontWeight:'Bold'}}>Tasación SII:&nbsp;</Typography>
                              <Typography variant="caption">
                                <NumberFormat displayType={'text'}
                                                  value={this.state.objects[index].vehiculo_sii.tasacion}
                                                  prefix={'$'} />
                              </Typography>
                            </Box>
                            <Button color='primary'
                                      startIcon={<HighlightOffIcon/>}
                                      color='secondary'
                                      onClick={(event) => this.handleUpdateFactibilizacion(event,{index:index, sii_reset:true})}
                                      >
                                Eliminar Tasación
                              </Button>
                          </Box>
                          }
                          { this.state.objects[index].sii_es_factura &&
                          <Box>
                            { !this.state.html.edit_monto_factura[index] &&
                              <Box>
                              <Box>
                                <Typography variant="caption" >
                                  <Box sx={{fontWeight:'Bold', display:'inline'}}>Monto Factura:</Box>
                                  <NumberFormat   displayType={'text'}
                                                  value={this.state.objects[index].sii_monto_factura}
                                                  decimalScale={2}
                                                  prefix={'$'} />
                                </Typography>
                              </Box>
                                <Box>
                                  <Typography variant="caption" >
                                    <Box sx={{fontWeight:'Bold', display:'inline'}}>Monto Tasación:</Box>
                                    <NumberFormat   displayType={'text'}
                                                    value={this.state.objects[index].sii_calculo_tasacion}
                                                    decimalScale={2}
                                                    prefix={'$'} />
                                  </Typography>
                                </Box>
                                <Button onClick={event=>this.editMontoFactura(index)}>
                                  Editar
                                </Button>
                              </Box>
                            }
                            { this.state.html.edit_monto_factura[index] &&
                              <Box>
                                <Box p={1}>
                                  <TextField  label='Monto total factura'
                                              name='sii_monto_factura'
                                              id='sii_monto_factura'
                                              InputProps={{
                                                inputComponent: NumberFormatCustom,
                                              }}
                                              fullWidth={true}
                                              inputProps={{ maxLength: 30 }}
                                              value={this.state.objects[index].sii_monto_factura}
                                              onChange={(event)=>this.handleInputChange(event,index)}
                                              />
                                </Box>
                                { this.state.objects[index].sii_monto_factura &&
                                <Box>
                                  <Button color='primary'
                                        startIcon={<SyncIcon/>}
                                        color='primary'
                                        onClick={(event) => this.handleUpdateFactibilizacion(event,{index:index, sii_monto_factura:this.state.objects[index].sii_monto_factura})}
                                        >
                                    Actualizar tasación
                                  </Button>
                                </Box>
                                }

                                <Button color='secondary' onClick={event=>this.editMontoFactura(index)}>
                                  Cancelar editar
                                </Button>
                                

                              </Box>
                            }


                            
                          </Box>
                          }
                          { [0,1,2].includes(this.state.objects[index].estado_sii) &&
                          <Box>

                            <Box p={1}>
                              <FormControlLabel control={<Switch  name='sii_es_factura'
                                                                  id={this.state.objects[index].sii_es_factura+this.state.objects[index].factibilizacion_uuid}
                                                                  onChange={(event) => this.handleUpdateFactibilizacion(event,{index:index, sii_es_factura:event.target.checked})}
                                                                  checked={this.state.objects[index].sii_es_factura}
                                                        />}
                                                label="Esta tasación es por factura" />
                            </Box>
                            { !this.state.objects[index].sii_es_factura &&
                            <Box>
                              <Box p={1}>
                                <Button color='primary'
                                        startIcon={<SearchIcon/>}
                                        onClick={event=>this.openDialogSii(index)}>
                                  Buscar tasación
                                </Button>
                              </Box>
                            </Box>
                            }
                          </Box>
                          }
                        </Grid>

                      </Grid>

                    </CardContent>
                  </Card>
                </Box>
                )
              })}
            </Box>
            }
            {this.state.objects.length===0 && !this.state.objects.cargando_lista &&
            <Box>
              
              <Box p={1}>
                <Alert severity='warning'>
                  Aún no hay vehículos cargados
                </Alert>
              </Box>

            </Box>
            }
          </Box>



          <Dialog   open={this.state.dialog_sii.open}
                    onClose={this.closeDialogSii}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={true}
                    maxWidth={false} >
            <DialogContent>
              {this.state.dialog_sii.open && this.state.dialog_sii.current_index !== null && 
                <VehiculoSii  marca={this.state.dialog_sii.marca} 
                              modelo={this.state.dialog_sii.modelo}
                              modelo_completo={this.state.dialog_sii.modelo_completo}
                              agno={this.state.dialog_sii.agno}
                              current_index = {this.state.dialog_sii.current_index}
                              handleImportSii = {this.handleImportSii}/>
              }
            </DialogContent>
            <DialogActions>
              <Button onClick={this.closeDialogSii} color="secondary">
                Cancelar
              </Button>
              <Button onClick={null} color="primary" variant='contained'>
                Continuar
              </Button>
            </DialogActions>
          </Dialog>

        </Box>
    );
  }
}

export default Factibilizaciones;
